import React, { Fragment, useMemo } from 'react';
import { observer } from 'mobx-react';
import ThemedProgress from './themed/ThemedProgress';
import {
    Heading2,
    FlexDiv,
    SpaceBetweenDiv,
    palette,
    StatusBadge,
    Image,
} from '@awarego-ui/components';
import styled from 'styled-components';

const PageCentralizedHeading2 = styled(Heading2)`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    align-items: center;
`;

function ViewHeader({
    onClose,
    hideClose,
    isDemo,
    isInfosec,
    brandingLoaded,
    logo,
    account_name,
    isFinished,
    isStarted,
    done,
    desktopMainHeading,
    desktopRightCorner,
    mobileMainHeading,
    mobileSubheading,
    mobileRightCorner,
}) {
    const closeButton = useMemo(() => {
        if (hideClose) return null;
        return (
            <Image
                className="ag-player-close"
                src="/static/img/close.svg"
                alt="Close"
                onClick={onClose}
                link
            />
        );
    }, [onClose, hideClose]);

    const demoBadge = useMemo(() => {
        if (!isDemo) return;
        return <StatusBadge text="DEMO" color={palette.vibrant.blueberry} />;
    }, [isDemo]);

    return (
        <Fragment>
            <SpaceBetweenDiv
                className="ag-player-header"
                minHeight={72}
                px={48}
                dropShadowBelow
                positionRelative
                desktopOnly
                maxWidth={1560}
            >
                {(isDemo || isInfosec) && brandingLoaded ? (
                    <>
                        <FlexDiv>
                            <span style={{ marginRight: '10px' }}>
                                {closeButton}
                            </span>
                            <Image
                                className="ag-player-logo"
                                maxHeight={40}
                                maxWidth={130}
                                src={logo}
                                alt={account_name}
                                style={{ maxHeight: 40 }}
                            />
                        </FlexDiv>
                    </>
                ) : (
                    closeButton
                )}
                <PageCentralizedHeading2>
                    {desktopMainHeading}
                    {demoBadge}
                </PageCentralizedHeading2>
                {desktopRightCorner}
            </SpaceBetweenDiv>
            <FlexDiv
                className="ag-player-header"
                minHeight={72}
                px={24}
                py={16}
                dropShadowBelow
                gap={16}
                fullWidth
                mobileOnly
                justifyCenter={isDemo || isInfosec || undefined}
                $noWrap
                alignCenter
            >
                {!(isDemo || isInfosec) && closeButton}
                <FlexDiv
                    column
                    gap={4}
                    justifyCenter={!isStarted || isFinished || undefined}
                >
                    <FlexDiv alignCenter gap={4}>
                        {mobileMainHeading}
                        {demoBadge}
                    </FlexDiv>
                    {mobileSubheading}
                </FlexDiv>
                {mobileRightCorner}
            </FlexDiv>
            <div className="wizard-header-progress ag-player-progress-wrap">
                <ThemedProgress narrow value={done} />
            </div>
        </Fragment>
    );
}

export default observer(ViewHeader);
